import React from "react";
import "./SuccessModal.css";
import img from "../../assets/success-check.png";
import { useLanguage } from "../../LanguageProvider";
import {
  PET_CAMPAIGN_CODE,
  PET_CAMPAIGN_MODAL_FOOTER,
  PET_CAMPAIGN_MODAL_TITLE,
  PET_CAMPAIGN_VALIDITY
} from "../../utils/petCampaign";

const SuccessModal = ({ onClose, message, campaign }) => {
  const { getTranslation } = useLanguage();
  const fallbackMessage = getTranslation("requestSubmitted");
  return (
    <div className="success-modal-overlay">
      <div className="success-modal-content">
        <img src={img} alt="success" className="success-modal-image" />
        <h2 className="success-modal-title">
          {getTranslation("paymentCompletedTitle") || "Ödemeniz Tamamlandı"}
        </h2>
        <p className="success-modal-message">{message || fallbackMessage}</p>
        {campaign?.isVisible && (
          <div className="success-modal-campaign-card">
            <div className="success-modal-campaign-title">
              {campaign.title || PET_CAMPAIGN_MODAL_TITLE}
            </div>
            <div className="success-modal-campaign-code-box">
              {campaign.code || PET_CAMPAIGN_CODE}
            </div>
            <div className="success-modal-campaign-validity">
              {campaign.validity || PET_CAMPAIGN_VALIDITY}
            </div>
          </div>
        )}
        {campaign?.isVisible && (
          <p className="success-modal-campaign-footer">
            {campaign.footer || PET_CAMPAIGN_MODAL_FOOTER}
          </p>
        )}
        <button className="success-modal-button success" onClick={onClose}>
          {getTranslation("close")}
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
